var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62492 3.83337C8.62492 3.4882 8.3451 3.20837 7.99992 3.20837C7.65474 3.20837 7.37492 3.4882 7.37492 3.83337V8.00004C7.37492 8.21553 7.48593 8.41583 7.66867 8.53004L10.1687 10.0925C10.4614 10.2755 10.847 10.1865 11.0299 9.89379C11.2129 9.60108 11.1239 9.21548 10.8312 9.03254L8.62492 7.65364V3.83337Z",
    fill: "#04D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 0.708374C3.97284 0.708374 0.708252 3.97296 0.708252 8.00004C0.708252 12.0271 3.97284 15.2917 7.99992 15.2917C12.027 15.2917 15.2916 12.0271 15.2916 8.00004C15.2916 3.97296 12.027 0.708374 7.99992 0.708374ZM1.95825 8.00004C1.95825 4.66332 4.6632 1.95837 7.99992 1.95837C11.3366 1.95837 14.0416 4.66332 14.0416 8.00004C14.0416 11.3368 11.3366 14.0417 7.99992 14.0417C4.6632 14.0417 1.95825 11.3368 1.95825 8.00004Z",
    fill: "#04D9FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4660362f42aef8f402e3d1d76ed056db.svg";
export { ForwardRef as ReactComponent };